<template>
  <ag-button
    class="clipboard"
    :class="externalClass"
    @click="copyThis"
  >
    <span
      v-if="text"
      class="clipboard__text"
    >
      {{ text }}
    </span>
    <ag-icon
      v-if="icon"
      name="copy"
      class="clipboard__icon"
    />
    <textarea
      class="clipboard__area"
      v-model="value"
      ref="area"></textarea>
  </ag-button>
</template>

<script>
// @see https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
import AgButton from '@/components/shared/AgButton.vue';
import AgIcon from '@/components/shared/AgIcon.vue';

/**
 * @vuese
 * give a String/Number `value` property and display a button
 * to copy this value into users clipboard
 */
export default {
  name: 'ag-clipboard',
  components: {
    AgButton,
    AgIcon,
  },
  props: {
    // a String/Number value to be clipboard copyable
    value: {
      type: [String, Number],
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    externalClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * copy components `value` into users clipboard
     * check if clipboard api is available, as a fallback oldschool
     * clipboarding is executed
     */
    copyThis() {
      if (window.navigator.clipboard) {
        window.navigator.clipboard.writeText(this.value);
        return;
      }
      const selected = document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;

      this.$refs.area.select();
      document.execCommand('copy');
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      } else {
        this.$el.focus();
      }
    },
  },
};
</script>

<style lang="scss">
.clipboard {
  padding: em(4px);
  border-color: transparent;
  display: inline-block;

  &__icon {
    color: inherit;
  }

  &__area {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    font-size: 1rem; // prevent iOs from zooming?
  }
}
</style>
